import React from "react";
import Welcome from "../components/Welcome";
import Primera from "../components/Primera";
import Resultado from "../components/Resultado";
import Formulario from "../components/Formulario";
import { Container, Row, Col } from "react-bootstrap";
import { Switch, Route, HashRouter } from 'react-router-dom';
import { TestFunction } from "../components/context/TestContext";


const Home = () => {
    return (
        <>
            <HashRouter>
                <TestFunction>
                    <Container>
                        <Row>
                            <Col>
                                <Switch>
                                    <Route exact path="/">
                                        <Welcome />
                                    </Route>
                                    <Route exact path="/preguntas/:idPregunta">
                                        <Primera />
                                    </Route>
                                    <Route exact path="/resultado">
                                        <Resultado />
                                    </Route>
                                    <Route exact path="/formulario">
                                        <Formulario />
                                    </Route>
                                </Switch>
                            </Col>
                        </Row>
                    </Container>
                </TestFunction>
            </HashRouter>
        </>
    );
}

export default Home;